import excelImportor from './excelImportor.vue'

export default excelImportor;


// WEBPACK FOOTER //
// ./src/components/customComponents/excelImportor/index.js